const campaignStatistics = {
  title: 'Campaign statistics',
  loadError: 'Unable to load the campaign statistics.',
  goalProgress: 'Goal progress',
  totalPledged: 'Total pledged',
  goal: 'Goal',
  ofGoal: 'of goal',
  noGoal: 'No goal set for this campaign.',
  oneTimeGifts: 'One-time donations',
  installmentsCollected: 'Installments collected',
  feesCovered: 'Fees covered by donors',
  futureInstallments: 'Future installments',
  kpiGifts: 'Donations',
  kpiGiftsHint: 'Total donations to this campaign',
  kpiDonors: 'Donors',
  kpiDonorsHint: 'Unique donors',
  kpiAverageGift: 'Average donation',
  kpiAverageGiftHint: 'Pledged per donation',
  kpiInstallmentShare: 'Paid in installments',
  kpiInstallmentShareHint: 'Share of donations on a payment plan',
  kpiFeeDonors: 'Donors covering fees',
  kpiFeeDonorsHint: 'Donors who added the fee',
  donationsOverTime: 'Donations over time',
  daily: 'Daily',
  weekly: 'Weekly',
  count: 'Donations',
  amount: 'Amount',
  oneTime: 'One-time donations',
  installment: 'Installment donations',
  runningTotal: 'Running total',
  noDonations: 'No donations for this campaign yet.',
  planMix: 'One-time vs installments',
  threeMonths: '3-month plans',
  sixMonths: '6-month plans',
  twelveMonths: '12-month plans',
  otherPlan: 'Other plans',
  planLength: 'Plan',
  share: 'Share',
  installmentPlans: 'Installment plans',
  active: 'Active',
  completed: 'Completed',
  pastDue: 'Past due',
  expectedMonthly: 'Expected monthly',
  activeHint: 'Plans currently being collected',
  completedHint: 'Fully paid plans',
  pastDueHint: 'Plans with a failed payment',
  expectedMonthlyHint: 'Across active plans',
  collected: 'Collected',
  scheduled: 'Still scheduled',
  noInstallments: 'No installment plans for this campaign.',
  canceledPlansExcluded: '%count% canceled plan(s) excluded.',
  adminFeeCoverage: 'Admin fee coverage',
  feeDonorsCovered: 'Donors covering fees',
  feeDonorsCoveredHint: 'Donors who added the fee',
  optInRate: 'Opt-in rate',
  optInRateHint: 'Share of donors who added the fee',
  charityPaid: 'Paid by charity',
  charityPaidHint: 'Fees not covered by donors',
  shareCovered: 'Share covered',
  shareCoveredHint: 'Share of fees covered by donors',
  weeklyFees: 'Fees covered per week',
  feeDonor: 'Donor',
  date: 'Date',
  feeAmount: 'Fee',
  status: 'Status',
  anonymous: 'Anonymous',
  feeNotEnabled: 'Fee coverage is not enabled for this campaign.',
  feeDataUnavailable: 'Fee coverage data is not available for this campaign.',
  noFeeDonors: 'No donors added the fee for this campaign.',
  allDonations: 'All donations',
  donor: 'Donor',
  paymentType: 'Payment type',
  allPaymentTypes: 'All payment types',
  pledged: 'Pledged',
  remaining: 'Remaining',
  noMatchingDonations: 'No donations match this payment type.',
  rowsPerPage: 'Rows per page',
  of: 'of',
  donationsCount: '%count% donations',
  warningTruncated: 'Some records were truncated because the campaign has more data than can be loaded at once.',
  warningDonationsUnavailable: 'Donations could not be loaded. Figures may be incomplete.',
  warningInvoicesUnavailable: 'Invoice details could not be loaded. Collected amounts and plan statuses may be incomplete.',
};

export default campaignStatistics;
